import axiosInstance, { errorHandler } from "./api";

const login = axios => payload => {
  delete axios.defaults.headers.common.Authorization;

  return axios
    .post("/api/authenticate", payload)
    .then(({ data }) => data)
    .then(({ id_token }) => {
      axios.defaults.headers.common.Authorization = `Bearer ${id_token}`;
      return id_token;
    })
    .catch(errorHandler);
};

const fetchUserData = axios => username => {
  return axios
    .get(`/api/user-infos/login/${username}`)
    .then(({ data }) => data)
    .catch(errorHandler);
};

const changePassword = axios => payload => {
  return axios
    .post("/api/account/change-password", payload)
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  login: login(axiosInstance),
  fetchUserData: fetchUserData(axiosInstance),
  changePassword: changePassword(axiosInstance),
};
